import { Component, Input, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { AppConfig } from '../../../../app/app.config';
import { GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { PtKendoGridDirective } from '../../../../_foundation/kendo/directives/pt-kendo-grid/pt-kendo-grid.directive';
import phaseGridConfig from './project-detail-phase-grid.config';
import { KendoGridColumnConfig, KendoGridDataConfig } from '../../../../_foundation/kendo/models/grid.models';
import { ProjectDetailService } from '../../../../services/setup/project-detail.service';
import { State } from '@progress/kendo-data-query';
import { ProjectDetailStageGridPage } from '../project-detail-stage-grid/project-detail-stage-grid';

@IonicPage()
@Component({
  selector: 'page-project-detail-phase-grid',
  templateUrl: 'project-detail-phase-grid.html',
})
export class ProjectDetailPhaseGridPage {
  @ViewChild('grid') grid?: GridComponent;
  @ViewChild('ptKendoGrid') ptKendoGrid: PtKendoGridDirective;

  projectId: number;
  projectName: string;

  config = AppConfig.settings;
  loading: boolean = false;
  gridConfig: KendoGridColumnConfig = phaseGridConfig;
  gridData: GridDataResult;
  gridDataConfig: KendoGridDataConfig;

  public state: State = {
    take: 15,
    sort: phaseGridConfig.defaultSort,
  };

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private projectDetailService: ProjectDetailService) {
    this.projectId = this.navParams.get('projectId');
    this.projectName = this.navParams.get('projectName');

    this.gridDataConfig = this.projectDetailService.getPhaseGridDataConfig(this.projectId);
  }

  ionViewDidLoad() {
    this.loadGrid();
  }

  private loadGrid(): void {
    if (this.ptKendoGrid) {
      this.ptKendoGrid.updateGrid().subscribe(res => {
        this.gridData = res;
      });
    }
  }

  viewStagesGrid(row: any) {
    this.navCtrl.push(ProjectDetailStageGridPage, {
      projectId: this.projectId,
      projectName: this.projectName,
      phaseId: row.id,
      phaseName: row.name});
  }
}



// WEBPACK FOOTER //
// ./src/pages/setup/project-details/project-detail-phase-grid/project-detail-phase-grid.ts